// @ts-nocheck
/* eslint-disable */
export const docDocumentIcon = {
    data: ``,
    name: 'doc-document' as const
};